export const scorePercentagesEnum = {
  Crystals: 'X',
  Clear: 'C',
  Other: 'O',
  Precipitate: 'P',
  'Crystal-else': 'XE',
  Micro: 'ML',
  Plate: 'PL',
  Spherulite: 'S',
  '3D': '3D',
  Needle: 'N',
  Rods: 'R',
  Contaminants: 'CN',
  'Phase Separation': 'PS',

  getCharacter: function (str) {
    return this[str] || null;
  },
};
